import memoize from 'lru-memoize';
import {createValidator} from 'utils/validation';
import productForm from './product.json';
import sitesForm from './sites.json';
import * as validators from 'utils/validation';
import _ from 'underscore';

var validateSite = {};

_.each(sitesForm, (group, key)=>{
	
	if ( key == 'Configuration du FTP prestataire' ){
		_.each(group.inputs, (input)=>{
			validateSite[input.name] = input.rules.map(s => validators[s]);
		});
	}
	
	
})


var validateProduct = {};
for(var group in productForm ) {
	var groupObj = productForm[group];
	for(var el in groupObj ) {
		// Validation conditionnelle pour identification_GSM selon le type
		if(groupObj[el].name === 'identification_GSM') {
			validateProduct[groupObj[el].name] = [(value, data) => {
				// Si ASC-IP, valider comme EQUIPSN
				if(data && data.product && data.product.identification_type === 'ASC-IP') {
					return validators.isValidEQUIPSN(value);
				}
				// Sinon, valider comme numéro de téléphone
				return validators.isValidNumber(value);
			}];
		} else {
			validateProduct[groupObj[el].name] = groupObj[el].rules.map(s => validators[s]);
		}
	}
}


const productValidation = createValidator([{'product':validateProduct}, {'site':validateSite}]);

export default memoize(10)(productValidation);